import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NavigationService } from "src/app/providers/navigation.service";
import * as QRCode from "qrcode";
import html2canvas from "html2canvas";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { environment } from "src/environments/environment";
import { tap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
@Component({
  selector: "sm-qr-code",
  templateUrl: "./qr-code.component.html",
  styleUrls: ["./qr-code.component.scss"],
})
export class QrCodeComponent implements OnInit, OnDestroy {
  panelState: any = [true, false, false, false, false];
  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  public loader: boolean = false;
  entityHashId: string = "";
  qrcodes: any = null;
  toRefresh: boolean = false;
  private _apiSubscription = new Subscription();
  base_url: string = environment.base_lookzup_market_mobile_website_url;
  @ViewChild("qrCodeCanvas") qrCodeCanvas!: ElementRef;
  @ViewChild("captureContainer", { static: false })
  captureContainer!: ElementRef;
  @ViewChild("qrCodeCanvas2") qrCodeCanvas2!: ElementRef;
  @ViewChild("captureContainer2", { static: false })
  captureContainer2!: ElementRef;
  @ViewChild("qrCodeCanvas3") qrCodeCanvas3!: ElementRef;
  @ViewChild("captureContainer3", { static: false })
  captureContainer3!: ElementRef;
  constructor(
    private _navService: NavigationService,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private route: ActivatedRoute,
    private _snackbar: MatSnackBar
  ) {
    this._navService.hideSidebarAndNav = false;
  }
  qrLink: any;
  ngOnInit(): void {
    console.log("reached here");
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
    });

    this.loader = true;
    this.loaderservice.showLoader = true;
    this._apiService.getLatestBookingQRCode(this.entityHashId);
    console.log("reached");

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_BOOKING_QR) {
        console.log(resData);
        this.qrcodes = resData.result ? resData.result : [];
        if (this.qrcodes.length > 0) {
          this.qrcodes[0].business_qr_info =
            typeof this.qrcodes[0].business_qr_info == "string"
              ? JSON.parse(this.qrcodes[0].business_qr_info)
              : this.qrcodes[0].business_qr_info;
          // this.qrcodes[0].home_qr_info = typeof this.qrcodes[0].home_qr_info == 'string' ? JSON.parse(this.qrcodes[0].home_qr_info) : this.qrcodes[0].home_qr_info
          // this.qrcodes[0].service_status = typeof this.qrcodes[0].service_status == 'string' ? JSON.parse(this.qrcodes[0].service_status) : this.qrcodes[0].service_status
          // this.qrcodes[0].shop_qr_info = typeof this.qrcodes[0].shop_qr_info == 'string' ? JSON.parse(this.qrcodes[0].shop_qr_info) : this.qrcodes[0].shop_qr_info
          // this.qrcodes[0].virtual_qr_info = typeof this.qrcodes[0].virtual_qr_info == 'string' ? JSON.parse(this.qrcodes[0].virtual_qr_info) : this.qrcodes[0].virtual_qr_info

          if (this.qrcodes[0].business_qr_info) {
            this.QRAvailable = true;
            this.QRdata = this.qrcodes[0].business_qr_info;
            this.qrLink =
              this.base_url + "/qrcode/kiosk?qr_id=" + this.QRdata.qrCode;
          }
          // if(this.qrcodes[0].service_status.shop_service_status != 2){
          //   this.toShowShop = true
          //   if(this.qrcodes[0].shop_qr_info){
          //     this.shopQRAvailable = true
          //     this.shopQRData = this.qrcodes[0].shop_qr_info

          //   }
          // }
          // if(this.qrcodes[0].service_status.virtual_service_status != 2){
          //   this.toShowVirtual = true
          //   if(this.qrcodes[0].virtual_qr_info){
          //     this.virtualQRAvailable = true
          //     this.virtualQRData = this.qrcodes[0].virtual_qr_info

          //   }
          // }

          // this.qrcodes.forEach((element:any) => {
          //   element.link = this.base_url + '/qrcode/booking?qr_id=' + element.qr_code + '&type=' + element.booking_type
          //   if(element.booking_type == '0'){
          //     this.homeQRAvailable = true
          //     this.homeQRdata = element
          //   }
          //   else if(element.booking_type == '1'){
          //     this.shopQRAvailable = true
          //     this.shopQRData = element
          //   }

          // });
          if (this.toRefresh == true) {
            this.toRefresh = false;
            this.getQrCodes().then((value) => {
              if (value && value != "null" && value != null) {
                console.log("yesss");
                this.generateQRCode(this.qrcodes);
              }
            });
          }
        }
        this.loader = false;
        this.loaderservice.showLoader = false;
      }

      if (resData.responseType === SM_CONSTANTS.RESULT_API_CREATE_BOOKING_QR) {
        if (resData.result) {
          this.toRefresh = true;
          this._apiService.getLatestBookingQRCode(this.entityHashId);
          // window.location.reload()
          // this.hardReload()
        }
      }
    });
  }
  ngAfterViewInit(): void {
    this.getQrCodes().then((value) => {
      if (value && value != "null" && value != null) {
        console.log("yesss");
        this.generateQRCode(this.qrcodes);
      }
    });
  }
  QRAvailable: boolean = false;
  QRdata: any;
  homeQRAvailable: boolean = false;
  homeQRdata: any;
  shopQRAvailable: boolean = false;
  shopQRData: any;
  virtualQRAvailable: boolean = false;
  virtualQRData: any;
  toShowShop: boolean = false;
  toShowHome: boolean = false;
  toShowVirtual: boolean = false;
  generateQRCode(urls: any): void {
    if (urls.length > 0) {
      console.log(urls);
      if (
        urls[0].business_qr_info &&
        urls[0].service_status.home_service_status != 2
      ) {
        this.QRAvailable = true;
        this.QRdata = urls[0].business_qr_info;
        QRCode.toCanvas(
          this.qrCodeCanvas.nativeElement,
          urls[0].business_qr_info.qrLink,
          (error) => {
            if (error) {
              console.error("Error generating QR code:", error);
            }
          },
        );
      }
      // if(urls[0].shop_qr_info && urls[0].service_status.shop_service_status != 2){
      //   this.shopQRAvailable = true
      //   this.shopQRData = urls[0].shop_qr_info
      //   QRCode.toCanvas(this.qrCodeCanvas.nativeElement, urls[0].shop_qr_info.qrLink, (error) => {
      //     if (error) {
      //       console.error('Error generating QR code:', error);
      //     }
      //   });
      // }
      // if(urls[0].virtual_qr_info && urls[0].service_status.virtual_service_status != 2){
      //   this.virtualQRAvailable = true
      //   this.virtualQRData = urls[0].virtual_qr_info
      //   QRCode.toCanvas(this.qrCodeCanvas3.nativeElement, urls[0].virtual_qr_info.qrLink, (error) => {
      //     if (error) {
      //       console.error('Error generating QR code:', error);
      //     }
      //   });
      // }
      // urls.forEach((element:any) => {
      //   if(element.booking_type == '0'){
      //     this.homeQRAvailable = true
      //     this.homeQRdata = element
      //     QRCode.toCanvas(this.qrCodeCanvas2.nativeElement, urls[0].home_qr_info.link, (error) => {
      //       if (error) {
      //         console.error('Error generating QR code:', error);
      //       }
      //     });
      //   }
      //   else if(element.booking_type == '1'){
      //     this.shopQRAvailable = true
      //     this.shopQRData = element
      //     QRCode.toCanvas(this.qrCodeCanvas.nativeElement, urls[0].home_qr_info.link, (error) => {
      //       if (error) {
      //         console.error('Error generating QR code:', error);
      //       }
      //     });
      //   }
      //   else if(element.booking_type == '2'){
      //     this.virtualQRAvailable = true
      //     this.virtualQRData = element
      //     QRCode.toCanvas(this.qrCodeCanvas3.nativeElement, urls[0].home_qr_info.link, (error) => {
      //       if (error) {
      //         console.error('Error generating QR code:', error);
      //       }
      //     });
      //   }
      // });
      // console.log(this.homeQRAvailable,this.shopQRAvailable,this.virtualQRAvailable);
    }
  }
  downloadQR() {
    html2canvas(this.captureContainer.nativeElement).then((canvas) => {
      // Convert canvas to an image URL
      const screenshotUrl = canvas.toDataURL("image/png");

      // Create a link and trigger download
      const link = document.createElement("a");
      link.href = screenshotUrl;
      // link.download = 'QR_' + this.parentData.data + '.png';
      link.download = "QR_" + new Date().getTime() + ".png";
      link.click();
    });
  }
  downloadQR2() {
    html2canvas(this.captureContainer2.nativeElement).then((canvas) => {
      // Convert canvas to an image URL
      const screenshotUrl = canvas.toDataURL("image/png");

      // Create a link and trigger download
      const link = document.createElement("a");
      link.href = screenshotUrl;
      // link.download = 'QR_' + this.parentData.data + '.png';
      link.download = "Home_QR_" + new Date().getTime() + ".png";
      link.click();
    });
  }
  downloadQR3() {
    html2canvas(this.captureContainer3.nativeElement).then((canvas) => {
      // Convert canvas to an image URL
      const screenshotUrl = canvas.toDataURL("image/png");

      // Create a link and trigger download
      const link = document.createElement("a");
      link.href = screenshotUrl;
      // link.download = 'QR_' + this.parentData.data + '.png';
      link.download = "Virtual_QR_" + new Date().getTime() + ".png";
      link.click();
    });
  }

  generateQR(type: string) {
    // this.loader = true
    this.loaderservice.showLoader = true;
    let data = {
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      edited_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      business_hash_id: this.entityHashId,
      booking_type: type,
    };
    this._apiService.createBookingQRCode(data);
  }

  public getQrCodes(): Promise<any> {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        const value = this.qrcodes;
        if (value) {
          clearInterval(intervalId);
          resolve(value);
        }
      }, 500); // Poll every second (adjust as needed)
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  hardReload() {
    this.ngOnDestroy(); // Manually destroy the component
    this.ngOnInit(); // Manually reinitialize the component
  }

  copyInputMessage() {
    navigator.clipboard
      .writeText(this.qrLink)
      .then(() => {
        this._snackbar.open("Business kiosk QR code link successfully copied", "Ok", {
          duration: 3000,
        });
        // Success message or feedback can be added here
        // alert('Message copied to clipboard');
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }
}
